// src/lang/zh-TW.js （繁体中文）
export default {
    menu: {
        home: '首頁',
        about: '關於我們',
        aboutGroup: '集團介紹',
        corporateCulture: '品牌文化',
        brandHistory:'品牌歷程',
        brandPromotion:'品牌宣传',
        news:'集團新聞',
        productShowcase:'集團產品',
        teaSeries: '茶業系列',         // 茶业系列（泛指茶叶相关产品）
        teaDrinkSeries: '茶飲系列',  // 茶饮系列（强调饮品形态）
        teaSetSeries: '茶器系列',  // 茶器系列（茶具、器皿类）
        teaBanquetSeries: '茶宴系列', // 茶宴系列（茶主题宴席）
        teaCabinSeries: '茶艙系列',      // 茶舱系列（若指茶空间/仓储相关）
        groupControl: '集團管控',  // 集团管控
        jobRecruitment: '人才招募',  // 人才招纳（繁体中"招纳"常用"招募"表达，更符合习惯）
        socialResponsibility: '社會責任',  // 社会责任
        publicWelfare: '公益幫扶助力',        // 公益帮扶助力
        agricultureView: '三農優選計劃',     // 三农优选计划（"三农"为大陆术语，繁体中可直接使用，或根据受众调整为"農業、農村、農民"相关表述）
        villageView: '鄉村振興戰略',         // 乡村振兴战略
        healthyChina: '健康中國品牌',        // 健康中国品牌
        contact: '聯繫我們'                  // 联系我们
    },
    message: {
        langSwitchSuccess: '切換語言成功',
        langChinese: '已為您切換至中文繁體模式',
        // ... 其他提示文本
    },
    products: {
        title: '系列產品'  // 对应“系列产品”的键
    },
    AboutUsSection: {
        title: '構築百年企業    傳承荊楚文化',
        text: '三皮罐，源於荊楚民間傳統，承載著400年的文化記憶。相傳神農嘗百草時發現，三片海棠葉入罐沖泡，七日不餿，故得名「三皮罐」。這一獨特的茶飲文化，深深植根於荊楚大地，見證了代代相傳的生活智慧。',
        text2: '作為中國大健康產業品牌運營商，三皮罐集團積極響應「健康中國2030」戰略和「三茶統籌」理念，將茶文化、茶產業、茶科技深度融合，我們不止於做茶，更在締造一種健康、自然、可持續的生活方式，致力於打造具有荊楚特色的茶文化服務綜合體和多元化產業格局。',
        text3: '集團紮根荊楚，胸懷世界，在北京、上海、武漢、廣州、深圳、成都、重慶等城市設立城市辦公室，在香港設立國際中樞平台。以萬畝茶園為根基，依托優質水源，運用現代茶科技，建設智能化超級工廠、天下茶艙、源茶基地、天然水基地等重點項目。致力於將千年茶香與現代健康消費完美融合，以三皮罐茶、水、器、時、空五大產品線對話世界。'
    },
    AboutUsSectionStats: {
        farm: '種植基地',
        factory: '超級工廠',
        experience: '服務經驗',
        city: '覆蓋城市',
        unitMu: '畝',
        unitYear: '年',
        unitPlus: '+'
    },
    brandProText: {
        title: '三皮罐大健康', // 品牌名通常不变，或按繁体习惯微调
        slogan: '自然、健康、正能量',
        description: '三皮罐的魅力，在於它用最簡單的原料和工藝，詮釋了「大道至簡」的東方智慧。無論是傳統沖泡的質樸，還是現代罐裝的便捷，它始終以「天然、健康、回甘」為核心，既承載著四百年的文化記憶，又滿足著現代人們對健康品質生活的追求。正如三皮罐集團總經理鮮文亮所言：「我們不是在做飲料，而是在傳遞一種生活方式。」這種將自然、傳統與創新融為一體的特質，讓三皮罐成為一款值得品味、收藏和分享的「有故事的產品」。'
    },
    sectionRenewal: {
        title: '5X煥新而來', // “焕”繁化为“煥”，“来”繁化为“來”
        subtitle: '傳荊楚文脈 • 造健康生活' // “传”繁化为“傳”，“脉”繁化为“脈”
    },
    moreBtn:'瞭解更多',
    fiveXItems: [
        {
            title: '茶',
            relationship: '茶業',
            icon: 'icon-chaye',
            description: '一葉承千古'
        },
        {
            title: '水',
            relationship: '茶飲',
            icon: 'icon-chayin',
            description: '一飲潤乾坤'
        },
        {
            title: '器',
            relationship: '茶器',
            icon: 'icon-chaqi',
            description: '一罐傳千年'
        },
        {
            title: '時',
            relationship: '茶境',
            icon: 'icon-chajing',
            description: '一境納百川'
        },
        {
            title: '空',
            relationship: '茶界',
            icon: 'icon-chajie',
            description: '一界開新元'
        }
    ],
    EnterpriseNewsTitle:'企業動態',
    ViewDetails:'查看詳情',
    FooterBar: {
        title: '服務熱線',
        menuTitle: '關於我們',
        about: '集團介紹',
        Culture: '品牌文化',
        news: '新聞動態',
        qxtitle: '旗下產品',
        chaye: '茶業',
        chayin: '茶飲',
        chaqi: '茶器',
        chayan: '茶宴',
        chacang: '茶艙',
        responsibility: '責任與公益',
        publicWelfare: '公益之行',
        responsibilityView: '社會責任',
        Copyright: '版權所有 三皮罐大健康產業集團',
        siteMapView: '網站地圖',
        adminLogin: '管理登錄',
        goToData:'品牌數據',
        goToTea:' 全球茶譜',
        ImageUploader: '上傳圖片'
    },
    proCultureImages: {
        culture1: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909694.png',
        culture2: 'https://pic1.imgdb.cn/item/68fb7ce73203f7be00988e67.png',
        culture3: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909696.png',
        culture4: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be00909699.png',
        culture5: 'https://pic1.imgdb.cn/item/68f9a1f53203f7be0090969a.png'
    },
    posterBut: {
        ViewButton: '戳我查看詳情',
        CloseButton: '關閉海報'
    },
    CultureBanner:{
        slides: [
            {
                imageUrl: 'https://pic1.imgdb.cn/item/68fc49f83203f7be009d2437.jpg',
                altText: '中國大健康產業品牌運營商',
                title: '中國大健康產業品牌運營商',
                description: '踐行國家戰略 聚焦產業發展 傳承荊楚文化 構築百年企業'
            }
        ],
        textContainer: {
            title: '大健康產業集團',
            description: '作為中國大健康產業品牌運營商，三皮罐集團深度踐行「健康中國 2030」戰略與「三茶統籌」理念，將茶文化、茶產業與茶科技三者深度融合。我們不止於深耕茶飲領域，更致力於締造健康、自然、可持續的現代生活方式，旨在構建兼具荊楚特色與國際視野的茶文化服務綜合體及多元化產業生態。',
            description2: '集團紮根荊楚沃土，胸懷全球發展格局，已在業務佈遍北京、上海、廣州、深圳、武漢、重慶、成都等核心城市設立城市辦公室，並於香港搭建國際中樞平台，構建起覆蓋全國、鏈接世界的運營網絡。以萬畝生態茶園為產業根基，依托優質天然水源，借力現代茶科技，重點建設智能化超級工廠、天下茶艙、源茶基地、天然水基地等核心項目，為產業發展筑牢堅實壁壘。',
            description3: '我們始終致力於將千年荊楚茶香與現代健康消費需求深度融合，以「茶、水、器、時、空」五大核心產品線為載體，向世界傳遞中國茶的健康價值與文化魅力。'
        },
        content: {
            title: '非遺代表 百年匠心 技藝傳承',
            desc: '三皮罐茶是湖北地區獨具特色的傳統飲品，以野海棠樹葉（學名湖北海棠）為原料，因「三片葉子泡一壺茶」而得名。現存最早關於三皮罐飲用的文獻證據可追溯至明末清初，湖北天門地方文獻《狀無施茶錄》（宋人何夢桂撰，清代修訂）記載了竟陵（今天門）地區僧人施茶傳統，其茶葉原料與製作方式與三皮罐特徵高度吻合。三皮罐茶製作技藝歷史文化淵源深厚，既是農耕文明的縮影，也是鄉土情感的載體。',
            coreTitle: '一、自然與人文的共生',
            coreText: '三皮罐的流行與湖北的自然環境密不可分。野海棠樹適應性強，耐旱抗寒，廣泛分佈於荊山餘脈、江漢平原等地，尤以荊州、荊門、鍾祥等地為盛。當地農人常在房前屋後種植此樹，形成「田頭砂壺三皮罐」的田園景象。',
            coreTitle2: '二、鄉愁與詩意的交織',
            coreText2: '三皮罐承載著湖北人的鄉土情結。遊子離鄉時常攜帶一包樹葉，以茶味寄託鄉愁，「烈日如蒸蟬聲斷，鄉野酣歇戴帽輕。田頭砂壺三皮罐，沁人心脾解暑餳」。三皮罐樸實無華的特質，亦被比作農人的品格。',
            coreTitle3: '三、非遺保護與創新融合',
            coreText3: '隨著時代變遷，三皮罐的文化價值逐漸被重視。三皮罐涼茶作為漳河新區非物質文化遺產代表性項目，已不僅僅是飲品，更成為鄉村振興的文化符號，並通過文旅融合、非遺教育等途徑煥發新生。',
            coreTitle4: '歷史文化淵源',
            coreText4: '自明代以來，三皮罐的歷史文化發展經歷了茶飲發端、社會普及、工藝精進與文化沉澱以及當前的品牌重塑與全球化拓展四個階段。',
            coreTitle5: '一、茶飲發端：從野生到茶飲(明代之前)',
            coreText5: '明萬曆《湖廣通志》記載：「江漢間有海棠樹，葉厚可熬飲，民謂之土茶」，證實其從野生資源向生活用品的轉化節點，「湖北海棠」也由此得名。2024年湖北鍾祥明顯陵出土的陶罐內殘留物經檢測含湖北海棠葉黃酮類物質，與三皮罐茶成分一致，為明代中葉江漢平原飲茶習俗提供物證。最終因「三片葉泡一罐」的定量沖泡方式得名三皮罐，成為江漢平原夏季解暑飲品，融入端午采葉、田間勞作等民俗場景。',
            coreTitle6: '二、社會普及：從日常藥用到軍需儲備(1900年-1957年)',
            coreText6: '1915年《中華藥典》湖北分卷正式收錄三皮罐的學名「湖北海棠葉」，並首次科學證實其核心活性成分「根皮苷」的降血糖功效，這與民間長期將其稱為「消渴茶」的實踐認知形成完美互證。抗戰時期(1943年)被列為軍需物資，荊州檔案館留存調撥單顯示年供應量達12萬斤，凸顯其社會功能拓展。',
            coreTitle7: '三、工藝沉澱：(1958-2023年)',
            coreText7: '三皮罐茶使用凝清葉片作為茶材，天然香氣與清新的口感使其廣受歡迎，尤其是荊門地區，民間詩歌為證：「田頭砂壺三皮罐，沁人心脾解暑餳」。1932年《荊門縣實業調查報告》首次系統記錄其製作流程：「端午采葉，竹匾陰乾，陶罐存儲，沸水沖沏」強調傳統工藝的穩定性。長期三皮罐以家庭自製的形式存在。原料採用當地特有的湖北海棠葉，製作工藝簡單。這一時期的生產完全依賴手工，未形成規模化，但已融入荊門地方飲食文化，成為夏季解暑的必需品。',
            coreText77: '1958年湖北省供銷社將其納入「土特產品購目錄」，推動家庭作坊向規模化生產過渡。隨著健康飲食理念興起和市場經濟的興起，三皮罐的工藝改良提上日程：一是原料篩選與種植：湖北海棠的規模化種植試驗在荊門等地展開，嘗試優化葉片採收周期和品質。二是加工技術革新：引入殺青機、揉捻機等設備，替代傳統日曬和手工揉捻，提升效率並減少雜質污染。三是產品形態拓展：開發袋泡茶、速溶粉等便捷形式，但市場接受度有限，仍以散裝茶葉為主。',
            coreTitle8: '四、品牌重塑與市場拓展',
            coreText8: '2024年武漢輕工大學研究證實其茶湯pH值(5.8-6.2)與天然抑菌性(綠原酸與根皮苷協同作用)，為工業化提供理論支持。2024年，三皮罐大健康集團在荊門漳河新區成立，標誌著規模化和品牌化生產的突破。',
            coreTitle9: '水源地建設',
            coreText9: '依托漳河優質水源，規劃建設現代化生產線，將傳統工藝與現代技術結合，推出罐裝茶產品。',
            coreTitle10: '品牌與文化整合',
            coreText10: '註冊「三皮罐」系列商標，挖掘其400年歷史底蘊，結合荊門地域文化進行品牌包裝。',
            coreTitle11: '產學研合作',
            coreText11: '與科研機構合作，提取海棠葉中的活性成分(如黃酮類化合物)，開發功能性飲品。',
            coreTitle12: '關鍵技術與突破',
            coreText12: '傳統工藝中「三片葉一壺茶」的配比被科學量化，通過恆溫萃取技術穩定茶湯色澤和口感。從荊門本地向湖北及周邊省份輻射，通過電商渠道進行地域擴張。將三皮罐與端午習俗、民間故事結合，申報非物質文化遺產，強化文化附加值。',
            coreTitle13: '地理區域',
            coreText13: '三皮罐茶製作技藝主要分佈於荊門市及周邊江漢平原地區，並延伸至湖北中部傳統飲用帶和部分省份。',
            coreText133: '荊門市下轄多個區、鎮和鄉，地理位置優越，交通便捷，地勢以山地、丘陵、平原為主，整體呈現江漢平原特徵，土壤肥沃，水源豐富。市內有多條河流穿流而過，主要河流包括長江的支流漢江，水系發達，為農業生產和海棠樹種植提供了得天獨厚的自然條件。',
            coreText1331: '水土資源的豐富使得該地區成為海棠樹種植的理想之地。荊門市屬於亞熱帶季風氣候，四季分明，夏季高溫多雨，冬季寒冷乾燥。適宜的氣候條件促使茶樹的生長旺盛，尤其在溫暖濕潤的季節，茶樹的生長速度較快，茶葉的品質也得以保證。荊門市的海棠樹多位於山坡、丘陵地區，這些地形條件利於茶樹的栽培，茶葉的口感鮮爽、清香。',
            coreText1332: '得益於豐富的水土資源和優越的氣候條件，荊門市的海棠樹種植歷史悠久，以三皮罐茶為代表，獨特的製作技藝使得該地成為三皮罐茶的重要產地之一。優越的自然環境和資源優勢為三皮罐茶製作技藝的傳承和創新提供了堅實的基礎，推動了荊門市茶文化的持續發展。',
            coreTitle14: '製作技藝',
            coreText14: '三皮罐茶葉的選材、採摘與製作工藝體現了傳統與現代的深度融合。從湖北海棠葉的嚴格篩選，到手工採摘的時令把控，再到無菌灌裝的技術創新。其成品既保留了民間飲品的文化底蘊，又通過標準化生產拓寬了市場應用，成為湖北茶文化的重要載體。',
            skillCards: {
                label: '選材精細',
                strong: '嫩葉：',
                li: '優先選用春季萌發的嫩芽和嫩葉，因其富含茶多酚、氨基酸等營養成分。',
                strong2: '完整：',
                li2: '葉片完整、無蟲蛀或霉斑。',
                strong3: '地域：',
                li3: '以湖北荊門、荊州等地的野生或規模化種植海棠樹為原料來源。'
            },
            skillCards2: {
                label: '茶葉採摘',
                strong: '時間：',
                li: '通常在清明節前後，茶樹新芽肥厚飽滿且富有香氣，營養積累充分，易形成豐富的口感層次。',
                strong2: '採摘：',
                li2: '以「一芽一葉」或「一芽二葉」為主，確保嫩度與香氣物質含量。保留葉片完整性，防止氧化。'
            },
            skillCards3: {
                label: '清洗除塵',
                strong: '清洗：',
                li: '將葉片清洗乾淨。',
                strong2: '除塵：',
                li2: '去除雜質和塵土。',
                strong3: '挑選：',
                li3: '清洗的過程中，對葉片的完整程度進行檢查。'
            },
            skillCards4: {
                label: '上籠蒸製',
                strong: '蒸製：',
                li: '清洗後的葉片進行蒸製，固定茶葉色澤與香氣。',
                strong2: '激發：',
                li2: '通過蒸汽的加熱，激發葉片中的天然香氣。',
                strong3: '保持：',
                li3: '保持茶葉的原色，使其更加耐泡清新鮮，提升茶葉整體品質。'
            },
            skillCards5: {
                label: '曬乾儲存',
                strong: '平鋪：',
                li: '蒸製後的海棠葉片平鋪竹匾上。',
                strong2: '通風：',
                li2: '陰涼通風處晾至半乾，再曬至全乾(避免暴曬)。',
                strong3: '晾曬：',
                li3: '曬乾後的茶葉呈現淺褐色，質地乾枯。',
                strong4: '儲存：',
                li4: '既便於儲存，又能最大程度保留茶葉的原香。'
            },
            skillCards6: {
                label: '泡製茶湯',
                strong: '傳統功效：',
                li: '生津止渴、清熱解毒，夏季消暑佳品。具有消積化滯、和胃健脾的功效。',
                strong2: '現代研究：',
                li2: '富含茶多酚、黃酮類物質，具抗氧化、促進代謝等潛力。'
            },
            manifestation: {
                title: '價值體現',
                subtitle: '一、經濟價值',
                normal: '三皮罐集團以漳河新區為核心，提出「水源地超級工廠」計劃，依托漳河一類水質資源開發罐裝涼茶產品，打造荊門本土健康飲品標杆。三皮罐茶作為獨特的茶葉製作工藝，逐漸成為市場上獨具特色的產品，吸引了茶葉愛好者與文化消費群體。通過三皮罐茶的品牌化運營及創新產品開發，相關企業和手工藝人不僅推動了傳統茶產業的發展，還拓展了茶文化相關的旅遊、禮品及文創產品市場，帶動了當地的經濟增長。結合現代電商平台的推廣，三皮罐茶也能快速地走向更廣泛的市場，進一步促進經濟效益的提升。',
                normal2: '3月22日「世界水日」，三皮罐集團與漳河新區簽署戰略協議，合作涵蓋生態產品研發、健康旅遊開發及水資源保護。新區政府表示，此舉將推動水經濟產業向高附加值方向升級。',
                normal3: '4月8日，三皮罐集團在第七屆世界大健康博覽會上與荊門市漳河新區簽約，宣布「天下茶艙」項目將於5月1日啟動運營。該項目整合茶科技、文旅康養資源，構建健康產業綜合體。'
            },
            manifestation2: {
                subtitle: '二、文化價值',
                normal: '三皮罐茶的製作方法，體現了茶文化與傳統哲學的有機融合，彰顯了古人對細節和工藝的追求。「三皮罐，喝不厭」，「砂壺茶，過盛夏」，每一杯三皮罐茶的製作，都是對傳統茶文化的再現和延續。集團加速推進三皮罐茶葉製作工藝及土陶罐技藝的非遺申請，計劃建設「水源地生態博物館」，通過展覽、天下茶艙等場景，將傳統工藝轉化為文化體驗項目。總經理鮮文亮提出「以茶和天下」理念，旨在讓三皮罐成為「荊門對話世界」的文化符號。'
            },
            manifestation3: {
                subtitle: '三、社會價值',
                normal: '在快節奏的生活方式中，三皮罐茶以其獨特的製作工藝和品飲方式，成為現代人追求內心寧靜、提升生活質量的一種方式。通過緩慢細緻的泡茶過程，人們能夠在靜謐的時光中找到身心的放鬆，調節情緒。此外，三皮罐茶的保護與推廣，也增強了公眾對傳統手工藝和文化遺產的認知與尊重，有助於社會對傳統文化的傳承和創新，為文化多樣性的保護和藝術傳承作出了貢獻，進一步增強了社會的文化凝聚力與認同感。三皮罐通過挖掘土地的社會價值(如粗陶壺、鏽紅色茶湯等記憶符號)，重塑品牌與城市的情感聯結。'
            },
            teaUpNew: {
                title: '"茶+"新業態',
                normal: '三皮罐大健康產業集團，是一家集多元產業布局與深厚地域文化底蘊於一體的綜合性企業，集團通過文化引領、科技賦能、產業支撐的深度融合，激發茶產業的多元價值。集團秉承「構築百年企業，傳承荊楚文化」的價值追求，踐行「荊門漳河水，荊楚三皮罐」的人文情懷，不僅致力於商業發展，還肩負著傳承和弘揚荊楚文化的使命，力求在推動經濟發展的同時，為社會文化傳承貢獻力量。',
                normal2: '泡三片海棠葉，解國民清涼——承載四百年江漢平原記憶的三皮罐茶，正從田間滿扇搖入現代產業鏈，三皮罐以傳統茶撬動健康消費浪潮，讓鄉愁滋味成為荊楚文化的新增長極。',
                subtitle: '茶葉產業',
                minor: '以綠色發展為方向，通過規模化種植、標準化加工和品牌化行銷，構建富民產業體系，夯實鄉村振興基礎。',
                subtitle2: '茶葉科技',
                minor2: '以創新技術驅動產業升級，涵蓋數字化管理、品種培育、生態種植等，提升茶葉生產效率和產品附加值。',
                subtitle3: '茶葉文化',
                minor3: '以歷史傳承和文化創意為核心，挖掘非遺技藝，講好品牌故事，為產業注入精神內核增強國際影響力。',
                subtitle4: '茶葉空間',
                minor4: '利用封閉式恆溫恆濕茶倉，運用先進的技術存儲確保茶葉品質打造超一流茶空間。',
                subtitle5: '茶葉服務',
                minor5: '以共享經濟為核心理念，助力產業升級，打造無人化管理服務體系提升茶產業競爭力。',
                subtitle6: '茶葉生活',
                minor6: '配備先進的設備，為三皮罐文化與產業的發展搭建起溝通交流的優質平台。'
            },
            featuresData: [
                {
                title: "全國產業布局",
                text: "覆蓋全國一線城市及主要樞紐，品牌高端化、渠道網路化、市場全國化。",
                img: "https://pic1.imgdb.cn/item/68ad2b8258cb8da5c84ef473.png"
                },
                {
                title: "三皮罐總部",
                text: "獨特「JM」建築形態打造荊門新地標。立面運用豎向鋁方通的疏密變化和玻璃幕牆的反射，巧妙演繹虛實關係呈現強烈的現代雕塑感，構成荊門獨特標誌性的現代化科技大廈。",
                img: "https://pic1.imgdb.cn/item/68ad2b8258cb8da5c84ef476.png"
                }
            ]
        }
    },
    corporateCulture:{
        slides: [
            {
                imageUrl: 'https://pic1.imgdb.cn/item/68fc6cb93203f7be009e37c9.jpg',
                altText: '承荊楚文化，築企業新篇',
                title: '承荊楚文化，築企業新篇',
                description: '從荊楚田間的一壺傳統涼茶，到輻射全國的大健康產業集團，三皮罐的發展歷程，始終是一部品牌文化與產業實踐深度交融的演進史',
                description2: '光陰流轉，我們以「天然、健康」為初心基因，以荊楚文化為精神內核，在產業擴張中沉澱文化底蘊，在文化傳承中驅動產業升級',
                description3: '讓這一源自民間的品牌，成為承載地域文脈、對話時代需求的國民符號'
            }
        ],
        BrandStory: {
            title: '三皮罐 · 品牌故事',
            subTitle: '三片葉子一罐茶 琥珀光裡蘊春秋',
            storyText1: '三皮罐，學名「湖北海棠」（Malus hupehensis），是湖北鄂西地區特有的天然茶飲，歷史可追溯至明末清初，其名稱來源於泡茶的方式，即三皮 (片) 茶葉泡一罐茶。',
            storyText2: '三皮罐的茶葉顏色枯黃，但泡製後味道清香、甘甜，具有',
            storyText2span: '生津解渴、清熱解暑、消炎殺菌',
            storyText22: '等功效。是一種具有獨特口感、豐富營養價值和深厚文化底蘊的涼茶飲料。因耐泡、解暑、物美價廉，而成為兩湖地區百姓夏日消暑的必備飲品。因而有詩曰：「烈日如蒸蟬聲斷，鄉野鋤禾戴帽氈。田頭砂壺三皮罐，沁人心脾解暑饞」。',
            storyText3: '得益於豐富的水土資源和優越的氣候條件，湖北地區的海棠樹種植歷史悠久，是三皮罐茶的重要產地之一。得天獨厚的資源優勢也為三皮罐茶製作技藝的傳承和創新提供了堅實的基礎，推動了湖北茶文化的持續發展。',
            storyText4: '如今，三皮罐的價值逐漸被重視，作為漳河新區',
            storyText4span: '非物質文化遺產',
            storyText42: '代表性項目，它不僅僅是飲品，更成為湖北地方文化的符號，當下正通過文旅融合、非遺教育等途徑煥發新生，在傳承創新中延續荊楚文化。',
            mainTitle: '三皮罐作為中國大健康產業品牌運營商',
            mainTitletext: '踐行「構築百年企業，傳承荊楚文化」的價值追求，秉承「荊門漳河水，荊楚三皮罐」的人文情懷，打造全產業鏈標桿的企業文化',
            valuesData: [
                {
                maxFont: "茶",
                title: "為人之道",
                text: "以茶載情，承續人文溫度",
                imgSrc: "https://pic1.imgdb.cn/item/689eaf3258cb8da5c8265839.png"
                },
                {
                maxFont: "水",
                title: "為茶之母",
                text: "以水立基，守護本真滋味",
                imgSrc: "https://pic1.imgdb.cn/item/689eaf3258cb8da5c826583b.png"
                },
                {
                maxFont: "器",
                title: "為茶之父",
                text: "以器傳藝，鏈接古今匠心",
                imgSrc: "https://pic1.imgdb.cn/item/689eaf3258cb8da5c8265832.png"
                },
                {
                maxFont: "時",
                title: "為茶之境",
                text: "以時為軸，平衡傳統與當下",
                imgSrc: "https://pic1.imgdb.cn/item/689eaf3258cb8da5c826583a.png"
                },
                {
                maxFont: "空",
                title: "為茶之界",
                text: "以空為場，重構生態場景",
                imgSrc: "https://pic1.imgdb.cn/item/689eaf3258cb8da5c8265833.png"
                }
            ],
            conceptData: [
                {
                title: "依托茶文化",
                imgSrc: "https://pic1.imgdb.cn/item/68a28d7658cb8da5c82bf77a.png"
                },
                {
                title: "運用茶科技",
                imgSrc: "https://pic1.imgdb.cn/item/68a28d7658cb8da5c82bf778.png"
                },
                {
                title: "推動茶產業",
                imgSrc: "https://pic1.imgdb.cn/item/68a28d7658cb8da5c82bf779.png"
                },
                {
                title: "發展新經濟",
                imgSrc: "https://pic1.imgdb.cn/item/68a28d7558cb8da5c82bf771.png"
                }
            ],
            items: [
                {
                title: "價值觀",
                text: "自然、健康、正能量",
                imgSrc: "https://pic1.imgdb.cn/item/68a2c6b358cb8da5c82ddf10.png"
                },
                {
                title: "生存之道",
                text: "琴棋書畫詩酒花，柴米油鹽醬醋茶",
                imgSrc: "https://pic1.imgdb.cn/item/68a2c6b358cb8da5c82ddf13.png"
                },
                {
                title: "情懷",
                text: "萬丈紅塵一壺酒，千秋大業一罐茶",
                imgSrc: "https://pic1.imgdb.cn/item/68a2c6b358cb8da5c82ddf14.png"
                }
            ],
            chacitems: [
                {
                title: '天下茶艙',
                description: '服務體系的點睛之筆，它讓荊楚文化與現代科技碰撞：智能煮茶、自動茶艙服務、茶室、民宿、休閒切換營造「一茶一境」，24小時自助服務打破時空限制，讓都市人在鋼筋森林中尋得一方「第三生活空間」。其外觀如星艦落塵，滿溢未來科技質感，宛如穿越時空的茶之驛站。',
                image: 'https://pic1.imgdb.cn/item/6906b7ee3203f7be00c244fe.jpg'
                },
                {
                title: '萬里茶道',
                description: '服務體系的文化脈絡。它循著古代商道的足跡，讓茶香飄溢世紀。如今，三皮罐以這一文化符號為引，既傳承荊楚文化的千年回響，也懷揣將中國茶文化推向世界的道路，讓古道茶香在當代煥發新生。',
                image: 'https://pic1.imgdb.cn/item/6906b7f33203f7be00c24514.jpg'
                },
                {
                title: '世代茶人',
                description: '服務體系的精神傳承。從古代茶農到現代從業者，一代又一代茶人守護著茶的本真，三皮罐珍視這份傳承，以「世代」為諾，讓製茶工藝、茶道精神在代際傳遞中愈發醇厚，如茶色般紅亮溫潤，悠遠綿長。',
                image: 'https://pic1.imgdb.cn/item/6906b7e93203f7be00c244ea.jpg'
                },
                {
                title: '根在荊楚',
                description: '服務體系的地域底色。三皮罐起源於明末清初的荊楚民間，農人以三片海棠葉煮涼茶解暑的習俗，藏著四代人的記憶。它在江漢平原、荊州、宜昌等地生根發芽，如今更以荊門為基，佈局北上廣深、香港等國際市場，讓荊楚茶味飄向更遠的地方。',
                image: 'https://pic1.imgdb.cn/item/68fc8efb3203f7be009e77e3.jpg'
                }
            ],
            brandData: [
                {
                imgSrc: "https://pic1.imgdb.cn/item/68a4362358cb8da5c8383d64.png",
                title: "中國健康品牌"
                },
                {
                imgSrc: "https://pic1.imgdb.cn/item/68a4360058cb8da5c8383d55.png",
                title: "鄉村振興攻略"
                },
                {
                imgSrc: "https://pic1.imgdb.cn/item/68a4362458cb8da5c8383d6b.png",
                title: "三農優選計劃"
                }
            ]
        }
    },
    BrandHistory:{
        banner:{
            title:'大事記',
            text:[
                '從荊楚茶脈的千年傳承到現代茶產業的創新實踐，從三片葉的匠心堅守到 “茶、水、器、時、空” 的生態佈局',
                '每一個關鍵節點都鐫刻著三皮罐踐行 “三茶統籌”、深耕大健康產業的足跡。翻閱此處，見證我們如何以茶為媒',
                '將文化底蘊、科技力量、健康理念、產業佈局融入發展歷程，一步步向 “依托茶文化、運用茶科技、推動茶產業、發展新經濟” 的願景邁進。'
            ]
        },
        breadcrumb:['首頁','企業介紹','品牌歷程'],
        mainTitle: '三皮罐發展歷程',
    },
    brandPromotion:{
        groInfo:{
            title:'承荊楚文化，築百年企業',
            text:[
                '當你刷到三皮罐的短視頻，讀到解析茶產業的深度長文，從螢幕裡的鮮活場景，到字裡行間的專業厚度',
                '三皮罐用多元內容織就品牌網絡，既讓茶葉、茶飲、茶器等產品的品質被看見，又讓「荊楚文化、三皮罐茶」等的品牌內核深入人心',
                '實現從「認產品」到「信品牌」的深度發展'
            ]
        },
        promotion:{
            title:'三皮罐·品牌生態',
            brandTitle:'從傳承荊楚文化，借「茶+數位」之力構築',
            desc:[
                '三皮罐以「茶文化+數位化」為重要支點，借電商直播、矩陣新媒體與數據驅動，構建「銷售轉化 - 品牌滲透 - 用戶共鳴」全渠道鏈路，推動傳統茶產業向大健康領域強勢破局。',
                '攜荊楚非遺涼茶基因破圈全國，讓承載千年地域記憶的茶湯，成為國民健康飲品新潮流。線上打造茶業、茶飲、茶器、時空等產品矩陣，以「茶+」模式整合產業資源，形成「生產 - 體驗 - 傳播」一體化大健康生態圈。從荊楚文化符號到全國大健康標桿，三皮罐正以創新之姿，定義茶界健康新典範。'
            ],
            online:{
                title:'線上旗艦店',
                subtitle:'產品覆蓋多個線上銷售平台'
            },
            liveTitle:'直播場景展示',
            videoTitle:'短視頻帳號運營'
        }
    },
    NewsList:{
        title:'新聞動態 NEWS',
        text:[
            "在品牌成長的征程中，三皮罐的每一次進階都凝聚著探索的力量。這裡的集團新聞，是我們與您對話的「動態窗口」",
            "既定格企業在產品創新、市場活動、社會責任上的深耕足跡，又解碼企業發展與消費需求的前沿信號",
            "感謝您的駐足關注，從這些鮮活的敘事裡，觸摸三皮罐的發展脈搏，共探產業未來的無限可能"
        ],
        moreBtn:'查看詳情',
        mainTitle:'新聞動態 NEWS',
        subTitle:'企業的成長都是一部波瀾壯闊的史詩，記錄市場的起伏更映射出時代的變遷與共同經歷的回顧，<br>更是對未來航程的期許與規劃。',
        breadcrumb:['新聞中心','新聞詳情'],
        meta:['三皮罐大健康產業集團','發布','來自微信公眾號文章','點擊查看公眾號新聞'],
        handleBack:'返回列表',
        nonews:'新聞不存在或已被刪除',
        time: {
            justNow: '剛剛',
            minuteAgo: '{n}分鐘前',
            hourAgo: '{n}小時前',
            dayAgo: '{n}天前',
            weekAgo: '{n}週前',
            monthAgo: '{n}月前',
            yearAgo: '{n}年前'
        }
    },
    ProductShowcase:{
        header:{
            title:'時空匠造・5X 產品',
            text:[
                '從荊楚「三皮罐」百年配方的時光沉澱中走來',
                '我們以茶業、茶飲、茶器、茶宴、茶艙構建5X產品矩陣，在時間維度堅守古法淬鍊工藝，融合現代萃取技術',
                '保留草本本真滋味，於空間維度覆蓋「品飲-使用-場景-體驗」全生態'
            ],
            breadcrumb:['首頁','5X產品詳情頁'],
        },
        content:{
            chaye:{
                title:'茶業',
                bgCharacter:'茶',
                h2:'三皮罐茶、恩施硒茶',
                text:[
                    '三皮罐品牌承載著深厚的荊楚文化底蘊，其歷史可追溯至明末清初時期，距今已有超過400年的歷史。這一獨特的名稱源於其最樸素的飲用方式——「三片茶葉泡一罐」，形象地詮釋了產品的核心特徵。',
                    '恩施茶葉的歷史可以追溯到非常久遠的年代。據《華陽國志・巴志》記載，「武王既克殷，以其宗姬封於巴，爵之以子……丹、漆、茶、蜜……皆納貢之……園有芳蒻、香茗。」這表明不晚於西周時期，恩施就已開始種茶樹、納茶貢。恩施，是我國茶樹起源地之一，茶葉種植歷史可追溯到東漢時期，《桐君錄》有文字記載，距離現在已有兩千多年。恩施州是「萬里茶道」的源頭之一，自唐代起就是著名的貢茶產區。',
                    '三皮罐恩施硒茶以其天然、健康的品質特徵在眾多茶葉產品中獨樹一幟。品牌堅守「天然、健康」的核心理念，致力於為消費者提供最純粹的茶飲體驗。'
                ]
            },
            chayin:{
                title:'茶飲',
                bgCharacter:'水',
                h2:'三皮罐涼茶',
                h3:'0添加，健康無負擔',
                text:'0能量，0香精、0色素、0防腐劑，滿足控糖人群需求。通過ISO 22000食品安全管理體系認證，品質安全有保障。',
                featureTitle:'經典配方，匠心傳承',
                desc:'以湖北荊楚地區傳統「三皮罐」配方為靈感，精選海棠葉為核心原料。科學配比，遵循古法淬鍊工藝，結合現代萃取技術，保留草本精華，去澀留香，適合四季飲用。',
                featureTitle2:'便捷罐裝，暢飲隨行',
                desc2:'採用310ml易拉罐包裝，密封鎖鮮，輕巧便攜，適合戶外、辦公、運動、聚餐等多種場景。',
                featureTitle3:'文化賦能，提升溢價',
                desc3:'三皮罐作為湖北非遺項目，與地域文化深度綁定，助力其從地方性飲品升級為全國性健康茶飲品牌。',
                productitle:'富鍶天然水',
                intro:'歷經千年岩層滲透、礦脈淬鍊，這一自然過程賦予了漳河水非凡的品質。富含多種對人體有益的礦物質和微量元素，讓漳河水的口感更佳的清澈、甘冽。三皮罐遵循自然法則，僅以物理方式提取、淨化，不添加、不干預，只為將這份來自大自然的純淨與滋養，原封不動地送至您的口中。',
                productitle2:'匠心天然',
                intro2:'在漳河核心保護區建立取水基地，遠離污染，確保每一滴水都源自天然純淨之源。採用國際領先的微濾、超濾技術，去除雜質的同時保留天然礦物質，全程無菌灌裝，杜絕化學添加，最大限度保留水的活性與天然口感。',
                productitle3:'鍶水滋養',
                intro3:'鍶是人体骨骼與牙齒的重要成分，可促進鈣質吸收，預防骨質疏鬆。天然鍶元素能清除體內自由基，延緩細胞老化，助您由內而外煥發年輕活力。鍶參與人體酶活性調節，促進新陳代謝，尤其適合運動後飲用，快速補充電解質，恢復體能。',
                tags:[
                    '北緯30°黃金緯度',
                    '富含多種微量元素',
                    '天然純淨無污染',
                    '鍶含量≥0.20mg/L',
                    'PH＞8.4'
                ]
            },
            chaqi:{
                title:'茶器',
                bgCharacter:'器',
                danxuanxiang:[
                    '從千年前屈家嶺的蛋殼黑陶，到唐代的邢窯白瓷、宋代的建窯兔毫盞，到如今匠人手作的紫砂壺、粗陶杯，茶器的材質與形態隨時代流轉，卻始終守著一份初心：以器承茶，以茶載情。',
                    '它不必奢華，卻藏著用心——杯沿貼合唇感，壺柄握得順手。觸摸茶器溫度，看茶湯在器中舒展，便是人與茶、與生活的溫柔對話。一杯茶的美好，從來離不開那隻懂它的「器」。',
                    '在荊楚文化脈絡中，陶器絕非普通盛茶器皿，而是匠人指尖流轉千年的匠心結晶，是茶飲與制陶技藝交融的活態遺產。',
                    '這份傳承深植制陶人骨血：從祖輩「選土觀色、揉泥聽聲」的口傳心授，到如今「不省工序、不湊火候」的堅守，每一代都以「守藝」託舉技藝，鄭重相傳。從選土到成器，每一步皆循古法細節裡藏著「器茶共生」的深刻理解——這是先輩總結的經驗、代代相傳的智慧，讓茶器既承三皮罐甘醇，更載歲月人文溫度。'
                ]
            },
            chayan:{
                title:'茶宴',
                bgCharacter:'時',
                intro:'茶宴之名，取自《茶經》，「茶為飲，最宜精行儉德之人」荊楚大地，枕江襟湖，魚米豐饒，孕育出「鮮、香、醇、厚」的飲食文化。茶宴匯聚江漢平原四時物產，借楚地煙火氣，演繹「一菜一格，百菜百味」的舌尖傳奇。茶宴不止提供美食，更致力於傳承楚菜精髓，弘揚荊楚文化。願君品盡世間味，歸來仍是自在人。',
                tag:['隨意·人生百態','隨緣·天人合一','隨心·禪茶一味'],
                tagsw:[
                    '茶宴之始，如人生初見，不求精緻，但求自在。有人匆匆而來，飽腹即可；有人攜友共聚，只求盡興。如市井煙火，茶可濃可淡，菜可鹹可甜，隨性而食，方顯生活本真。',
                    '茶至無味，方是真味；食至無求，方得至味。不拘於菜式，不執於口味，一箸一茶，皆是緣分。飲食不再是口腹之欲，而是自然文化的交融——茶中有天地，菜裡有春秋。',
                    '不再囿於飽腹之欲，而是尋味而食，擇心所向。或獨坐一隅，慢品一壺老茶，佐以清雅小點，茶香入心，禪意自生；或三五知己，點幾道合心意的菜肴，不貪多，不求全，只取所愛，食之有味.'
                ]
            },
            chacang:{
                title:'茶艙',
                bgCharacter:'空',
                desc0:'艙體採用鍍鋅環保材料建造，配備全屋智能控制語音系統、270°全景視窗及自助茶飲設備，用戶可通過小程序實現「一鍵預約、全程自助」的私享體驗，適用於商務、社交、休閒等多重場景',
                featureTitle:'全景沉浸式空間設計',
                desc:[
                    '270°環景視窗：',
                    '高透光率玻璃，無邊框設計，實現全景環繞視野，晝夜景觀無縫切換。',
                    '模組化艙體結構：',
                    '單艙12㎡，可容納2-6人，支持自由組合擴展。生態友好設計：空氣循環裝置，實現低碳運行。'
                ],
                danxuanxiang:'全屋智能控制系統',
                featureDesc:[
                    '語音交互：',
                    '支持中英文語音指令，控制燈光、溫濕度、背景音樂。',
                    '場景模式：',
                    '一鍵切換多種預設環境場景模式。',
                    '安全防護：',
                    '智能感應消防系統+緊急呼叫裝置，全程雲端保障。'
                ],
                danxuanxiang2:'智慧茶飲服務體系',
                desc2:[
                    '自助茶飲機：',
                    '提供多種精選茶品，AI智能推薦沖泡方案。',
                    '智能零食櫃：',
                    '掃碼即取本地特色茶點、健康輕食。',
                    '文化體驗：',
                    '內置茶道教學，體驗AI互動指導。'
                ],
                danxuanxiang3:'數字化運營支持',
                desc3:[
                    '預約系統：',
                    '微信小程序實時查看艙位狀態、景觀視角預覽、在線選艙及支付。',
                    '會員體系：',
                    '積分兌換專屬權益，更多優惠可選。',
                    '企業服務：',
                    '支持品牌專屬空間定制。'
                ]
            }
        }
    },
    groupControl:{
        header:{
            title:'集團管控・匠築生態',
            text:[
                '我們恪守「專業深耕、協同共贏」的經營底色，在戰略規劃、運營標準、中樞管控等維度層層錨定',
                '從產品矩陣的品質堅守，到分子公司的精准佈局，從重點項目的全鏈路發展，到產業生態的長效構建',
                '集團管控始終是我們踐行發展的硬核底盤。誠邀您共同見證我們以扎實管控筑牢發展根基、以長遠雄心擘畫品牌未來的篤定步伐'
            ]
        },
        mapTitel:'覆蓋全國一線城市及主要樞紐城市',
        mapData:[
            {name:'行政區域',number:'5'},
            {name:'省份',number:'10'},
            {name:'辦公場所',number:'40'},
            {name:'城市',number:'24'},
        ],
        mapInfo:[
            {region:'華南大区',info:['香港','深圳','廣州']},
            {region:'華東大区',info:['上海','泰安','金華','安慶']},
            {region:'華西大区',info:['成都','重慶','貴陽','烏魯木齊']},
            {region:'華北大区',info:['北京']},
            {region:'華中大区',info:['武漢','荊門','恩施','鍾祥','襄陽','宜昌','赤壁','仙桃','潛江','十堰','天門','京山']}
        ],
        cityImgData:[
            {
            name:'廣州·白雲·大都會',
            img:'https://pic1.imgdb.cn/item/68fb8fee3203f7be00994cfc.jpg'
            },
            {
            name:'武漢·洪山·保利國際中心',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655956.jpg'
            },
            {
            name:'深圳·福田·嘉里中心',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655959.jpg'
            },
            {
            name:'上海·浦東·華南大廈',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655958.jpg'
            },
            {
            name:'北京·西城·德勝大廈',
            img:'https://pic1.imgdb.cn/item/68b3a97158cb8da5c8655954.jpg'
            },
            {
            name:'成都·金牛·國賓時光匯',
            img:'https://pic1.imgdb.cn/item/68b3a97c58cb8da5c8655955.jpg'
            }
        ],
        addressList: [
            { title: '華北區北京辦公室', phone: '010-82960238', address: '北京市西城區皇寺大街德勝置業大廈1號樓1706' },
            { title: '華西區成都辦公室', phone: '028-85026677', address: '成都市金牛區金科北路一招鮮大廈' },
            { title: '華東區上海辦公室', phone: '021-56699999', address: '上海市浦東新區東方路1988號華南大廈404' },
            { title: '華中區武漢辦公室', phone: '027-83839015', address: '武漢市光谷電子工業園3期6棟東二樓' },
            { title: '華南區深圳辦公室', phone: '0755-23309999', address: '深圳市福田區中心四路1號嘉里建設廣場三座1404' },
            { title: '駐外香港辦公室', phone: '00852-60997141', address: '灣仔區告士打道200號 新銀集團中心2702' }
        ],
        infoItem:['電話：','地址：'],
        sectionTitle:'超級水工廠',
        desc:'依托漳河水庫連續14年穩定保持的國家Ⅰ類優質水源，三皮罐公司前瞻佈局200畝綜合性生產基地。未來，這裡不僅是智造中心，更將是「水+」產業的展示窗口，通過水資源與文旅、科技、農業的立體聯動，將生態優勢轉化為澎湃的發展動能。',
        sectionTitle2:'文化產業園',
        desc2:'根植於楚文化與三國史詩的厚重土壤，三皮罐在荊州，以一杯地方茶飲為基點，構築一個融匯品牌、體驗與創意的文化產業集群，旨在將地方風味升華為一張嶄新的城市文化名片。',
        sectionTitle3:'大健康產業園',
        desc3:'立足鐘祥「長壽之鄉」的生態稟賦，三皮罐打造以「大健康」為核心的「一核四驅」產業綜合體。通過聚合產品研發、共享直播、包裝生產與生活配套等功能，項目將形成閉環生態，驅動品牌升級與鄉村振興，為鐘祥經開區注入強勁發展活力。',
        sectionTitle4:'原茶基地',
        desc4:'三皮罐恩施茶工廠坐落於「世界硒都」湖北恩施宣恩縣，依托當地獨特的富硒土壤，專注茶葉全產業鏈運營。工廠以「地理優勢+品牌勢能+科技賦能」三位一體模式，深耕富硒健康茶飲賽道，打造具有硒都特色的標誌性品牌。',
        sectionTitle5:'光谷電商基地',
        desc5:'三皮罐正式落子武漢光谷，建立全新的電商與數字化運營基地。此舉旨在借助光谷的人才與科技資源，構建品牌面向未來的數字新基建，以創新營銷鏈接全國市場，開啟品牌發展的新篇章。',
        subtitle:'三皮罐聚焦武漢光谷，走向全國。',
        subText:[
            '運用現代科技手段，通過「技術+內容+規模」的協同增長體系，實現智能驅動提效+熱點追蹤造勢+矩陣號放量的品牌運營模式，致力打造「茶科技+楚文化」雙核驅動的華中茶業數字化中樞。',
            '通過「數字化供應鏈+文化IP」雙向賦能，激活萬億級茶消費市場。引領茶產業從傳統批發向「科技+文化」的數字化轉型升級。成為三皮罐走向全國的強大引擎。'
        ],
        subtitle2:'縉雲山水源地',
        subText2:'三皮罐集團以戰略遠見，於重慶北碚嘉陵江溫塘峽畔佈局生態智慧礦泉水基地。項目充分激活縉云山的生態稟賦與現有工業用地，以「工業+旅遊」模式聯動溫泉、文旅與康養，將縉云山的生態價值轉化為共生共榮的大健康產業生態圈。',
        subtitle3:'水源地生態條件優越',
        subText3:'縉云山礦泉水基地位於國家級自然保護區縉雲山麓，該區域森林覆蓋率極高，擁有2407種植物和1071種動物，生物多樣性豐富，形成了天然的生態屏障。',
        subtitle4:'水質天然且富含礦物質',
        subText4:'縉云山礦泉水屬於天然礦泉水，其鍶含量達1.17—1.82毫克/升，偏硅酸含量27毫克/升，均達到國家標準界限指標。鍶元素能軟化血管、強壯骨骼，偏硅酸則有助於調節神經和腸胃功能。',
        secondary:'未來，三皮罐集團將持續以茶文化激活產業底蘊，以茶科技突破發展邊界，在推動茶、水、器、時、空等核心產品創新發展的同時，深化茶產業鏈協同，培育新經濟業態。秉持「構築百年企業，傳承荊楚文化」的願景，集團將在鞏固發展優勢的基礎上拓展全球佈局，以產業創新賦能新經濟發展，全力向全國性產業領軍品牌、大健康產業標杆邁進。',
        hubeiCities:[
            { name: '武漢市', value: [114.3162, 30.5928, 100] },
            { name: '荊門市', value: [112.1900, 31.0200, 80] },
            { name: '荊州市', value: [112.2400, 30.3800, 70] },
            { name: '襄陽市', value: [112.1400, 32.0000, 90] },
            { name: '宜昌市', value: [111.3000, 30.7000, 85] },
            { name: '鐘祥市', value: [112.3400, 31.1000, 60] },
            { name: '恩施土家族苗族自治州', value: [109.4800, 30.1800, 75] },
            { name: '成都市', value: [104.0665, 30.5723, 95] },
            { name: '烏魯木齊市', value: [87.6168, 43.8256, 80] },
            { name: '貴陽市', value: [106.7135, 26.5783, 75] },
            { name: '安慶市', value: [117.0572, 30.5243, 70] },
            { name: '重慶市', value: [106.5504, 29.5637, 90] },
            { name: '廣州市', value: [113.2644, 23.1291, 100] },
            { name: '深圳市', value: [114.0579, 22.5431, 95] },
            { name: '濟南市', value: [117.0009, 36.6512, 85] },
            { name: '北京市', value: [116.4074, 39.9042, 100] },
            { name: '上海市', value: [121.4737, 31.2304, 100] } 
        ]
    },
    JobRecruitment:{
        title:'中國大健康產業品牌運營商',
        text:'構築百年企業  傳承荊楚文化',
        placeholder:'搜尋職位關鍵詞',
        searchBtn:'搜索職位',
        label:'歷史搜索',
        clear:'清空全部',
        address:'工作地址',
        jobNum:'發布崗位',
        jobInfo:[
            '投遞郵箱：',
            '手機號碼：',
            '聯繫方式：',
            '在招崗位：',
            '工作地點：',
            '刷新數據',
            '投送簡歷'
        ],
        jobList:[
            '招聘職位',
            '薪資',
            '工作地區',
            '人數',
            '學歷',
            '發布時間',
            '職位狀態',
            '查看詳情'
        ],
        status:['招聘中','已截止'],
        detail:['職位介紹','專業要求','任職要求'],
        dialogVisible:['職位詳情','招聘中','報名已截止','急','發布於','崗位介紹','崗位要求','福利待遇','工作地址','投遞郵箱','複製郵箱','發送簡歷','保存分享','取消','朕知道了'],
        office:['致未來同行者：','辦公環境'],
        historyKeywords: ['產品經理','美工人員','新媒體運營','視頻剪輯'],
    },
    publicWelfare:{
        header:{
            title:'踐行國家戰略・共擔時代責任',
            text:[
                '作為深耕行業的企業，三皮罐集團始終將社會責任視為發展的核心要義之一。我們以「公益幫扶助力發展，戰略踐行彰顯擔當」為理念',
                '積極投身公益事業，深度響應國家「三農優選」「鄉村振興」「健康中國」等戰略部署',
                '旨在與廣大客戶、各界關心三皮罐的朋友一道，凝聚社會責任的強大合力。讓我們與時代同頻，把企業責任的星火，變成共擔責任的燎原之勢'
            ]
        },
        welfare:{
            title:'三皮罐夏日送清涼',
            text:[
                '活動啟動儀式在荊門的京東河東島站點舉行。三皮罐集團與市場監管局、市「小個專」綜合黨委領導一同前往集團中天街站、美團象山站、順豐同城減河站等多個配送站點，為騎手們送上「三皮罐涼茶」等防暑物資，並叮囑大家注意防暑降溫。',
                '此次慰問活動不僅解決了騎手們在高溫作業中的實際需求，更彰顯了三皮罐集團對社會責任的擔當。通過聯合政府部門開展關愛行動，三皮罐進一步拉近了與消費者之間的距離，讓品牌「自然、健康、正能量」的形象深入人心。',
                '未來，三皮罐集團將持續深化對新就業群體的關愛舉措，攜手更多社會力量，完善常態化服務機制，用實際行動傳遞品牌溫度，為城市建設者送上更多健康與關懷。'
            ],
            footer:'三皮罐公益活動，用小小的一杯茶，傳遞著大大的愛。它不僅僅讓傳統茶飲煥發新生，更溫暖了無數人的心靈，讓公益之花在社會的各個角落綻放。'
        },
        section:{
            title:'三皮罐因愛而行',
            text:[
                '驕陽似火，酷熱難耐，三皮罐集團積極履行社會責任，開展了一場充滿愛心的公益行動。',
                '考慮到環衛工人們每日不辭辛勞，在高溫下堅守崗位，為城市的整潔默默付出，三皮罐集團精心準備了防暑降溫飲品三皮罐涼茶。集團工作人員帶著滿滿的誠意，將一箱箱涼茶送到正在街頭清掃的環衛工人手中，對他們的辛勤工作表達了誠摯的感謝和暖心的關懷。',
                '此次愛心行動，不僅為環衛工人們送去了夏日的清涼，更傳遞了社會對一線勞動者的尊重與關愛。三皮罐集團用實際行動詮釋了企業的擔當與愛心，為營造和諧美好的社會氛圍貢獻了自己的力量。相信這份愛心會如同夏日的清風，吹進每一個人的心田，激勵著更多人加入到關愛他人的行列中來。'
            ],
            footer:'三皮罐作為一家心懷大愛的企業，始終秉持著回饋社會的理念積極投身公益事業。用點滴善舉匯聚成愛的海洋，為社會公益事業貢獻著自己的堅實力量。'
        },
        SilverAge:{
            title:'「關愛銀齡退役軍人健康行」活動',
            text:[
                '荊門市「關愛銀齡退役軍人健康行」活動正式啟動，社會各界齊聚一堂，以行動致敬退役軍人的奉獻與擔當。三皮罐集團高度重視此次公益活動，為退役軍人及工作人員送去夏日清涼與關懷。三皮罐集團作為一家紮根荊門的綜合性大健康產業集團，對這次公益活動非常重視。此次助力添彩，不僅是物質支持，更承載著企業對退役軍人的崇高敬意。',
                '三皮罐集團深知退役軍人的艱辛不易，以及他們為國家所做出的奉獻。多年來，集團以多樣行動傳遞尊崇，以實際行動踐行社會責任。這不僅僅是一次物質上的支持，更是企業文化與社會責任的生動體現，彰顯了三皮罐集團作為本土企業的擔當與情懷。'
            ],
            footer:'從一杯涼茶的關懷出發，三皮罐集團正以堅定的步伐，書寫著「軍民同心」的新篇章。把這份關懷與敬意延續下去。力求在多個維度實現突破與發展，為社會創造更多價值。'
        }
    },
    agricultureView:{
        header:{
            title:'守護鄉村生態・傳承農耕文化',
            text:[
                '以「三茶統籌」築根基，以「茶 +」業態拓場景，以「5X 產品線」賦價值 —— 三皮罐三農優選計劃',
                '這一戰略不僅實現了企業產業佈局與三農發展的同頻共振，更以實際行動守護鄉村生態、傳承農耕文化',
                '彰顯了集團從「產業發展者」到「三農賦能者」的責任擔當，為推動農業增效、農民增收、農村增美提供了「三皮罐方案」'
            ]
        },
        section:{
            title:'以非遺技藝打造健康新方式',
            text:[
                '仲夏時節，驕陽似火，天地間萬物蓬勃生長，展現出旺盛的生命力。如何在順應自然規律的同時，運用科學的方法進行養生調養，成為當下大眾關注的焦點。近日，三農優選(中國農業電影電視中心新媒體平台)以《夏日養生局》為主題，精心籌備了一場別開生面的養生盛會，共同探索非遺技藝與現代科技的養生新主張。',
                '作為紮根湖北近20年的老牌企業，三皮罐集團一直致力於大健康產業的發展。如今積極響應國家「三茶統籌」理念，將業務版圖拓展至茶產業、特色文旅、生態農業、新型消費等多個領域，我們始終以「構築百年企業，傳承荊楚文化」為使命，以「依托茶文化、運營茶科技、推動茶產業、發展水經濟」為企業願景。將三皮罐打造成荊楚大地的文化名片，不斷探索創新，力求在傳承中發展，在發展中傳承。'
            ]
        },
        workmanship:{
            title:'工藝揭秘：獨特工藝鑄就品質',
            text:[
                '直播現場，鮮文亮總經理以親切而專業的姿態，向觀眾娓娓道來三皮罐涼茶的起源以及三皮罐品牌的初心。三皮罐涼茶承載著湖北地區悠久的茶文化歷史，是我們對傳統養生智慧的傳承與創新。我們始終堅信，每一杯三皮罐涼茶都不僅僅是一種飲品，更是一種文化的延續和情感的寄託，它承載著無數人兒時的記憶，是家鄉的味道，是親情的象徵。',
                '鮮文亮總經理著重對比了三皮罐涼茶與傳統茶飲料生產工藝差異。傳統茶飲料生產流程複雜，高溫消毒採用的技術雖能殺菌，但會破壞茶葉香氣，使味道變淡、口感變差。而三皮罐涼茶精選優質原葉，無需炒制與發酵，採用萃取工藝，經30分鐘122攝氏度恆溫二次萃取，充分釋放茶葉特性，保留天然香氣與營養成分，再經冷卻保鮮灌裝，最終口感醇厚、香氣四溢，盡顯對傳統工藝的尊重與現代科技的運用。'
            ]
        },
        makeanAppearance:{
            title:'直播赴約：攜誠意產品亮相盛會',
            text:[
                '6月15日，我們懷著滿腔的熱情和專業的態度，受邀參與了本次三農優選《夏日養生局》直播活動。湖北三皮罐大健康產業集團總經理鮮文亮親自帶隊，攜公司精心打造的三皮罐涼茶與三皮罐原葉禮盒產品，奔赴北京中國農業電影電視中心新媒體平台，參與這場備受矚目的直播節目錄製。我們希望通過這個平台，將三皮罐的品牌故事和養生理念傳遞給更多的人。'
            ]
        },
        fusion:{
            title:'產業融合：創新模式拓展養生版圖',
            text:[
                '此外，鮮文亮總經理還分享了三皮罐集團在生態農業與產業融合方面的創新突破。我們積極推動生態農業的發展，與當地農戶建立了緊密的合作關係，採用綠色、環保的種植方式，確保茶葉的品質和安全。同時，我們將茶產業與特色文旅、新型消費等領域相結合，打造了多元化的茶文化服務綜合體，為消費者提供了更加豐富、多元的養生體驗。'
            ]
        },
        includes:{
            title:'非遺科技融合，續寫養生新篇',
            text:[
                '此次參與《夏日養生局》直播活動，將會讓更多的人了解三皮罐品牌，認識三皮罐涼茶的獨特魅力。未來，我們將繼續秉承「自然、健康、正能量」的價值觀；以「構築百年企業，傳承荊楚文化」的使命，不斷加大研發投入，提升產品品質，拓展市場渠道，為廣大消費者帶來更多優質的養生產品和服務。我們相信，在非遺技藝與現代科技的融合下，三皮罐集團必將開啟養生新征程，書寫更加輝煌的篇章。'
            ]
        }
    },
    "villageView": {
        "header": {
            "title": "激活鄉土價值・共繪和美鄉村圖景",
            "text": [
                "集團鄉村振興戰略以國家鄉村振興戰略為根本遵循，以「茶」為核心紐帶激活鄉村內生動力，讓荊楚鄉土文化觸達更廣泛人群",
                "這一戰略不僅實現了企業產業優勢與鄉村發展需求的精準對接，更以生態優先、文化傳承為底線，在推動茶生態、技藝傳承的過程中",
                "為鄉村振興提供「產業興、農民富、農村美」的可複製實踐方案，彰顯了民族企業服務國家戰略、反哺鄉村發展的責任與擔當"
            ],
            "hero": "三皮罐的三茶項目在實現鄉村全面振興、共同富裕的過程中，扮演著提升鄉村文化品位、激活茶產業鏈經濟、促進農民增收與就業、以及推動鄉村可持續發展的關鍵角色，是連接傳統與現代、文化與經濟的重要橋樑。"
        },
        "content": {
            "title": "共同富裕戰略的積極響應",
            "feature": [
                "2025 年中央一號文件明確提出，要堅持農業農村優先發展，堅持城鄉融合發展，錨定推進鄉村全面振興、建設農業強國目標。三皮罐集團的鄉村振興計劃與這一國家戰略高度契合，通過產業帶動、文化賦能、科技創新等多重路徑，為實現共同富裕貢獻企業力量。",
                "從「產業發展、要素流動、服務提升、治理有效」四個維度出發，三皮罐集團構建了完整的鄉村振興生態體系。在產業發展上，集團以萬畝茶園為根基，依托茶文化，運用茶科技，推動茶產業發展；在要素流動上，通過「茶 +」新業態模式，促進資金、技術、人才等要素向農村流動；在服務提升上，建設「天下茶艙」等文化體驗設施，提升農村公共服務水平；在治理有效上，通過企業化運作模式，為鄉村治理現代化提供新路徑。"
            ],
            "agriculture": {
                "title": "農業農村科技現代化的創新實踐",
                "text": "《加快建設農業強國規劃 (2024-2035 年)》強調，要以農業關鍵核心技術攻關為引領，以產業急需為導向，加快以種業為重點的農業科技創新。三皮罐集團在這一戰略指引下，積極推進農業科技現代化，成為農業新質生產力的重要實踐者。"
            }
        },
        "Travel": {
            "title": "鄉村全面振興戰略的系統對接",
            "text": [
                "《鄉村全面振興規劃 (2024—2027 年)》要求統籌推進農村經濟建設、政治建設、文化建設、社會建設、生態文明建設和党的建設，實現鄉村全面提升。三皮罐集團的鄉村振興計劃與這一系統性要求高度吻合，形成了「五位一體」的綜合發展模式。",
                "在經濟建設方面，集團通過發展茶產業、水經濟、文旅產業等，構建多元化的產業體系。",
                "在文化建設方面，集團致力於傳承和弘揚荊楚文化，力求在推動經濟發展的同時，為社會文化傳承貢獻力量。三皮罐品牌起源於湖北荊楚民間傳統涼茶，當地農人以三片野海棠葉泡製解暑茶飲的習俗，承載著幾代人的記憶。集團通過產品創新和文化傳播，讓這一傳統飲品煥發新生。",
                "在生態建設方面，集團注重綠色發展，建設「水源地超級工廠」。通過水資源保護與利用、生態茶園建設、循環經濟發展等措施，實現經濟效益與生態效益的有機統一。",
                "在社會建設方面，集團積極履行社會責任，開展「夏日送清涼」活動，為環衛工人、快遞小哥等戶外工作者提供防暑飲品。2025 年 7 月，集團捐贈 1000 件防暑飲品，為守護城市潔淨的勞動者們送上貼心關懷。"
            ]
        },
        "innovation": {
            "title": "產業鏈整合的創新模式",
            "text": "三皮罐集團通過產業鏈整合，構建了「從茶園到茶杯到時間到空間」的全產業鏈體系，實現了一二三產業的深度融合。這種整合模式不僅提高了產業效率，更重要的是讓農民能夠分享產業鏈各環節的增值收益。"
        },
        "practice": {
            "title": "文旅融合的創新實踐",
            "text": "三皮罐集團將茶文化與旅遊產業深度融合，打造了獨特的茶旅融合模式。集團長期聚焦茶產業與大健康融合，通過整合文旅、農業資源，構建多元化健康產業綜合體。",
            "feat": {
                "title": "「天下茶艙」項目",
                "text": "「天下茶艙」項目是文旅融合的標誌性工程。太空茶艙以「未來茶空間」為概念，將荊楚茶文化與現代科技深度融合。營造「一茶一境」的沉浸式氛圍；24 小時自助服務通過掃碼預約、自助沖泡，讓茶文化突破時間與空間的限制，成為都市人的「第三生活空間」。"
            },
            "feat2": {
                "title": "「三皮罐之夜」演唱會",
                "text": "「三皮罐之夜」演唱會等文化活動成為文旅融合的新亮點。2025 年 10 月 6 日，「三皮罐之夜」華語巨星演唱會現場人潮攢動，2 萬餘名觀眾前來體驗這場音樂盛會，帶動周邊餐飲、住宿企業營業收入增長。這種「文化 + 旅遊 + 商業」的模式，不僅提升了城市知名度，也為當地經濟發展注入了新活力。"
            }
        },
        "promote": {
            "title": "多元擔當的社會價值",
            "text": [
                "在品牌賦能方面，集團通過品牌建設和市場推廣，提升產品附加值。三皮罐作為荊楚地區的傳統飲品，具有深厚的文化底蘊。集團通過現代營銷方式，將這一傳統產品打造成時尚健康的現代飲品，產業助力的成效是顯著的。",
                "三皮罐集團創新性地將農業、文化、旅遊三大產業有機結合，打造了具有荊楚特色的農文旅融合發展模式。集團通過整合文旅、農業資源，構建多元化健康產業綜合體，為鄉村振興探索了新路径。",
                "我們將持續提升三皮罐品牌的知名度和美譽度，打造成為具有荊楚特色、中國氣派、世界影響的民族品牌。要注重品牌文化內涵的挖掘和傳播，講好三皮罐故事，提升品牌價值。同時，要加強國際市場開拓，讓中國茶文化走向世界。",
                "展望未來，三皮罐集團的鄉村振興計劃正站在新的歷史起點上。隨著項目的深入推進和模式的不斷完善，這一計劃必將在推動鄉村全面振興、實現共同富裕的偉大實踐中發揮更大作用，為中國式現代化貢獻更多智慧和力量。我們有理由相信，在國家戰略的引領下，在企業的積極實踐中，在社會各界的共同努力下，鄉村振興的美好願景必將成為現實，億萬農民必將過上更加幸福美好的生活。"
            ]
        },
        "number": ["合作鄉村", "受益農戶", "收入增長", "旅遊人次"]
    },
    "HealthyChina": {
        "header": {
            "title": "踐行健康使命・守護美好生活",
            "text": [
                "三皮罐集團健康中國品牌戰略深度錨定「健康中國 2030」戰略目標，將「三茶統籌」理念作為健康產業發展的核心引擎",
                "以「茶」為健康載體構建全鏈條價值體系，以「天然、安全、可持續」的健康標準，為消費者提供全場景健康解決方案",
                "彰顯了民族企業以產業之力助推全民健康、服務國家戰略的堅定擔當"
            ]
        },
        "content": {
            "title": "打造全國影響力茶品牌",
            "text": [
                "固內佈局：錨定文化根脈，構建健康生態",
                "作為中國大健康產業的核心品牌運營商，三皮罐集團深度踐行「三茶統籌」發展理念，以傳承400餘年的荊州三皮罐茶文化為根基。依托百萬畝生態園與漳河天然水基地兩大核心資源，集團以茶產業為核、茶科技為翼，精準對接健康消費需求，建成智能化超級工廠與「天下茶艙」體驗空間等標桿項目。",
                "目前，集團已在北京、上海、廣州、深圳、武漢等10餘座核心城市設立城市辦公室，構建起覆蓋全國的運營網絡，並形成「茶、水、器、時、空」五大產品線體系，推動承載湖北人鄉愁記憶的傳統茶與現代健康生活方式深度融合。",
                "國際戰略：鏈接全球資源，打造國際品牌",
                "為提升國際競爭力，集團以香港為國際業務中樞，統籌全球資源對接與品牌推廣。通過整合產業鏈優勢與科技創新成果——如強化三皮罐中根皮苷等有益成分的開發利用，集團正全力打造兼具地域文化辨識度與國際適配性的茶文化服務綜合體，讓這一源自荊楚的千年茶飲名片走向世界"
            ]
        },
        "section": {
            "title": "科技賦能，文化傳承促發展",
            "text": "三皮罐集團積極響應國家號召，將茶產業作為新的發展重點，致力於推動鄉村產業振興與茶文化傳承。",
            "card": {
                "title": "恩施原茶基地",
                "text": "在恩施州打造「世界硒都」茶產業標桿項目，佔地面積6574㎡，廠房面積39966㎡，辦公樓452㎡，品茶室932㎡。通過科技賦能傳統茶業，發展硒茶葉深加工產業，預計年產值可達2億元，帶動當地茶農增收超千萬元。"
            },
            "card2": {
                "title": "武漢電商基地",
                "text": "依托「九省通衢」地理樞紐與長江經濟帶核心節點的物流優勢，以高校人才為智力引擎，為新媒體電商提供了人才、智能供應鏈基建、政府扶持及楚文化內容壁壘的四重戰略支點，計劃在武漢擬建1300㎡的新媒體電商運營基地，助力打造數字經濟新茶名片。"
            },
            "card3": {
                "title": "荊州茶文旅綜合產業園項目",
                "text": "2025年，集團旗下子公司依法通過司法拍賣取得荊州市荊州區兩處優質資產，土地使用權面積4662.73㎡，計劃投資打造集茶文化展示、生產研發、文旅服務於一體的綜合性項目。項目建成後，預計年接待遊客超10萬人次，帶動當地就業超500人。"
            }
        },
        "crossover": {
            "title": "跨界融合，創新驅動新未來",
            "text": "三皮罐集團在產業升級與轉型方面不斷探索與實踐，積極尋求跨界融合與創新發展。",
            "card": {
                "title": "重慶縉雲山泉水基地",
                "text": "成功競得縉雲山礦泉水生產基地，土地使用權82755.5㎡，建築面積12357.82㎡。基地採用全封閉式無菌生產鏈，建立水循環系統，動態調整開採量，確保水源可持續。預計年產量可達5000萬瓶，年產值超3億元。"
            },
            "card2": {
                "title": "鐘祥大健康產業園",
                "text": "投資建設以「大健康產業」為核心的「一核四驅」生態型商業綜合項目，佔地約200畝，總規劃建築面積超10萬㎡，計劃投資約5億元。項目涵蓋產品研發、共享直播、人才公寓、包裝生產、酒店餐飲等多個板塊，預計年產值可達8億元，帶動當地就業超1000人。"
            },
            "card3": {
                "title": "漳河水原地生產基地",
                "text": "依托漳河水庫優質水資源，投資建設綜合性生產基地。項目佔地約200畝，總規劃建築面積超10萬㎡，計劃投資約7.5億元。基地配備兩條高度自動化生產的灌裝生產線，生產速度可達單線3.6萬罐/時，全面投產以後，年總產量可達2000萬標箱，比傳統工廠節約用工60%以上。"
            },
            "card4": {
                "title": "綠色發展，共築美好未來",
                "text": [
                    "三皮罐集團作為一家多元化、跨領域發展的綜合性企業，在地產開發、茶產業與鄉村振興、產業升級與轉型等方面取得了顯著成就。",
                    "未來將繼續秉承「依托茶文化、運用茶科技、推動茶產業、發展新經濟」的願景，以茶科技賦能產業升級、以茶文化激活品牌價值、以茶產業帶動融合發展，加快打造具有全國影響力的三皮罐茶品牌。為地方經濟社會發展注入新動能，為共築美好未來貢獻。"
                ]
            }
        }
    },
    "ContactPage": {
        "header": {
            "title": "聯繫我們 共築聯結",
            "text": [
                "作為中國大健康產業品牌運營商，三皮罐集團始終以「真誠、高效、專業」的態度，搭建與廣大客戶、合作夥伴及關注者的溝通橋樑。",
                "這裡是您了解三皮罐、對接需求、共探發展的重要紐帶，我們以用心服務的溫度，傳遞品牌的專業品質與責任擔當。"
            ]
        },
        "message": {
            "title": "線上留言",
            "name": ["請輸入您的姓名", "您的姓名"],
            "contact": ["請輸入有效的電話或信箱", "聯絡電話或信箱"],
            "type": "請選擇留言類型",
            "option": [
                "產品諮詢",
                "購買諮詢",
                "售後諮詢",
                "品牌合作",
                "市場活動諮詢",
                "意見與建議",
                "招商加盟諮詢",
                "企業資訊諮詢",
                "其他業務"
            ],
            "captcha": "請輸入驗證碼",
            "content": ["請輸入留言內容（最多500字）", "請輸入留言內容"],
            "button": ["重置", "提交留言"],
            "cell": ["聯繫方式", "留言類型", "留言內容", "驗證碼"]
        }
    },
    "responsibilityView": {
        "header": {
            "title": "發展與責任共生 • 初心與使命同行",
            "text": [
                "2009年創立以來，三皮罐大健康產業集團始終紮根荊楚大地，以「構築百年企業，傳承荊楚文化」為價值追求",
                "在「文化引領、科技賦能、產業發展」的發展戰略中深度融入社會責任理念。從一片茶葉到多元產業生態，從地域品牌到全國佈局",
                "集團始終堅信：企業的長遠發展必然與社會價值創造同頻共振，社會責任不是發展的「附加題」，而是驅動高質量發展的「核心引擎」"
            ]
        },
        "section": {
            "title": "踐行國家戰略 共擔時代責任",
            "text": "作為深耕行業的企業，三皮罐集團始終將社會責任視為發展的核心要義之一。我們以「公益幫扶助力發展，戰略踐行彰顯擔當」為理念，積極投身公益事業，深度響應國家「三農優選」「鄉村振興」「健康中國」等戰略部署，旨在與廣大客戶、各界關心三皮罐的朋友一道，凝聚社會責任的強大合力。讓我們與時代同頻，把企業責任的星火，變成共擔責任的燎原之勢。"
        },
        "section2": {
            "title": "守護鄉村生態 傳承農耕文化",
            "text": "以「三茶統籌」築根基，以「茶 +」業態拓場景，以「5X 產品線」賦價值 —— 三皮罐三農優選計劃，這一戰略不僅實現了企業產業佈局與三農發展的同頻共振，更以實際行動守護鄉村生態、傳承農耕文化，彰顯了集團從「產業發展者」到「三農賦能者」的責任擔當，為推動農業增效、農民增收、農村增美提供了「三皮罐方案」。"
        },
        "section3": {
            "title": "激活鄉土價值 共繪和美鄉村圖景",
            "text": "集團鄉村振興戰略以國家鄉村振興戰略為根本遵循，以「茶」為核心紐帶激活鄉村內生動力，讓荊楚鄉土文化觸達更廣泛人群。這一戰略不僅實現了企業產業優勢與鄉村發展需求的精準對接，更以生態優先、文化傳承為底線，在推動茶生態、技藝傳承的過程中，為鄉村振興提供「產業興、農民富、農村美」的可複製實踐方案，彰顯了民族企業服務國家戰略、反哺鄉村發展的責任與擔當。"
        },
        "section4": {
            "title": "踐行健康使命 守護美好生活",
            "text": "三皮罐集團健康中國品牌戰略深度錨定「健康中國 2030」戰略目標，將「三茶統籌」理念作為健康產業發展的核心引擎，以「茶」為健康載體構建全鏈條價值體系，以「天然、安全、可持續」的健康標準，為消費者提供全場景健康解決方案，彰顯了民族企業以產業之力助推全民健康、服務國家戰略的堅定擔當。"
        }
    },
    "SiteMapView": {
        "title": "網站地圖"
    }
}
